export default __webpack_public_path__ + "done-1c2b70a31d70b012d11fe9739dbef6d8.png";